import React from 'react';
import { compose, setPropTypes, pure } from 'recompose';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import DetailTextButton from '../atoms/DetailTextButton';
import ChangeStatusMenuEventTextButton from '../atoms/ChangeStatusMenuEventTextButton';
import EditTextButton from '../atoms/EditTextButton';
import ShowHideTextButton from '../atoms/ShowHideTextButton';
// import listMenuChildTypes from '../../constants/MenuChildType';

const styles = {
  firstTableCell: {
    borderRight: '1px solid #e0e0e0',
    padding: 10
  },
  leftIcon: {
    padding: '0px 5px'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired,
  menus: PropTypes.arrayOf(
    PropTypes.shape({
      menuEventName: PropTypes.string,
      menuEventId: PropTypes.number,
      menuName: PropTypes.string,
      price: PropTypes.number,
      taxType: PropTypes.string,
      prefectures: PropTypes.string,
      groupName: PropTypes.string,
      // status: PropTypes.number,
      createdAt: PropTypes.string,
      updatedAt: PropTypes.string
    })
  ).isRequired
};

const enhance = compose(
  pure,
  setPropTypes(propTypes)
);

const UserTableBody = enhance(
  ({
    menus,
    emptyRows,
    page,
    rowsPerPage,
    detailOpenAction,
    changeStatusOpenAction,
    editOpenAction,
    // deleteOpenAction,
    showHideOpenAction,
    order,
    orderBy,
    handleRedirect
    // roles
  }) => {
    const sortedResult = _.orderBy(menus, orderBy, order);
    // const listMenuTypeHideEdit = ['DEFAULT'];
    return (
      <TableBody>
        {sortedResult
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map(gochiMenu => {
            const params = {
              id: gochiMenu.menuEventId,
              status: gochiMenu.status,
              showHide: gochiMenu.showHide
            };

            const key = `${gochiMenu.menuEventId}`;
            return (
              <TableRow key={key} hover>
                <TableCell>
                  <Button
                    color="primary"
                    onClick={() =>
                      handleRedirect(
                        `/gochi_menus_event/${
                          gochiMenu.menuEventId
                        }/gochi_event`
                      )
                    }
                  >
                    イベント連携
                  </Button>
                </TableCell>
                <TableCell>
                  <EditTextButton
                    id={gochiMenu.menuEventId}
                    onClickAction={editOpenAction}
                    disabled={gochiMenu.manual === 1}
                  />
                </TableCell>
                <TableCell>{gochiMenu.menuEventName}</TableCell>
                <TableCell>{gochiMenu.menuEventId}</TableCell>
                {/* <TableCell>
                  {listMenuChildTypes.map(item => {
                    if (parseInt(gochiMenu.menuChildType, 10) === item.id) {
                      return item.name;
                    }
                    return '';
                  })}
                </TableCell> */}
                <TableCell>{gochiMenu.menuName}</TableCell>
                <TableCell>
                  {gochiMenu.isETicket === 1 ? '電子' : '紙印刷'}
                </TableCell>
                <TableCell>{gochiMenu.price}</TableCell>
                <TableCell>{gochiMenu.taxTypeStr}</TableCell>
                <TableCell>{`${gochiMenu.premiumPercent}%`}</TableCell>
                <TableCell>{gochiMenu.displayAmount}</TableCell>
                {gochiMenu.prefectures && gochiMenu.group.groupName && (
                  <TableCell>
                    {gochiMenu.prefectures}
                    <br />
                    {gochiMenu.group.groupName}
                  </TableCell>
                )}
                {gochiMenu.prefectures && !gochiMenu.group.groupName && (
                  <TableCell>{gochiMenu.prefectures}</TableCell>
                )}
                {!gochiMenu.prefectures && gochiMenu.group.groupName && (
                  <TableCell>{gochiMenu.group.groupName}</TableCell>
                )}
                <TableCell>{gochiMenu.createdAt}</TableCell>
                <TableCell>{gochiMenu.updatedAt}</TableCell>
                <TableCell>
                  <ShowHideTextButton
                    params={params}
                    onClickAction={showHideOpenAction}
                    showHide={gochiMenu.showHide}
                    disabled={gochiMenu.manual === 1}
                  />
                </TableCell>
                <TableCell>
                  <DetailTextButton
                    params={params}
                    onClickAction={detailOpenAction}
                  />
                </TableCell>
                <TableCell>
                  {/* <DeleteTextButton
                    id={gochiMenu.menuEventId}
                    onClickAction={deleteOpenAction}
                  /> */}
                  <ChangeStatusMenuEventTextButton
                    params={params}
                    onClickAction={changeStatusOpenAction}
                    status={gochiMenu.status}
                    disabled={gochiMenu.manual === 1}
                  />
                </TableCell>
              </TableRow>
            );
          })}
        {emptyRows > 0 && (
          <TableRow style={{ height: 49 * emptyRows }}>
            <TableCell colSpan={7} />
          </TableRow>
        )}
      </TableBody>
    );
  }
);

export default withStyles(styles)(UserTableBody);
